import Vue from "vue";
import VueRouter from "vue-router";
import index from "@/views/index.vue";
import briefIntroduction from "@/views/briefIntroduction.vue";
// import contact from "@/views/contact.vue";
import entranceGuard from "@/views/product/entranceGuard.vue"
import store from "@/store";
import i18n from '@/plugins/i18n';


// 报错解决
// 获取原型对象push函数
const originalPush = VueRouter.prototype.push;

// 获取原型对象replace函数
const originalReplace = VueRouter.prototype.replace;

// 修改原型对象中的push函数
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err);
};

// 修改原型对象中的replace函数
VueRouter.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);

const routes = [
    {
        path: "/",
        name: "index",
        component: index,
        meta: {
            metaInfo: {
                title: i18n.t("router.index.title"),
                keywords: i18n.t("router.index.keywords"),
                description: i18n.t("router.index.description"),
            }
        },
    },
    {
        path: '/404',
        name: 'notfound',
        component: () => import("@/views/error/404.vue")
    },
    {
        path: '*',
        redirect: '/404'
    },
    // {
    //     path: "/briefIntroduction",
    //     name: "briefIntroduction",
    //     component: briefIntroduction,
    //     meta: {
    // 		metaInfo: {
    // 			title: "关于公司",
    // 			keywords: "杉脉介绍,",
    // 			description: "为客户提供产品技术支持、提供安防系统工程、综合布线、智能化系统集成工程、系统保养维护等项目的综合解决方案设计。"
    // 		}
    //     },
    // },
    {
        path: "/product/entranceGuard",
        name: "entranceGuard",
        component: entranceGuard,
        meta: {
            metaInfo: {
                title: i18n.t("router.entranceGuard.title"),
                keywords: i18n.t("router.entranceGuard.keywords"),
                description: i18n.t("router.entranceGuard.description"),
            }
        },
    },
    {
        path: "/product/displayCase",
        name: "displayCase",
        component: () => import("@/views/product/displayCase.vue"),
        meta: {
            metaInfo: {
                title: i18n.t("router.displayCase.title"),
                keywords: i18n.t("router.displayCase.keywords"),
                description: i18n.t("router.displayCase.description"),
            }
        },
    },
    {
        path: "/product/softwarePlatform",
        name: "softwarePlatform",
        component: () => import("@/views/product/softwarePlatform.vue"),
        meta: {
            metaInfo: {
                title: i18n.t("router.softwarePlatform.title"),
                keywords: i18n.t("router.softwarePlatform.keywords"),
                description: i18n.t("router.softwarePlatform.description"),
            }
        },
        children: []
    },
    {
        // 智能门禁软件
        path: "/product/softwarePlatform/entranceGuardSoftware",
        name: "entranceGuardSoftware",
        component: () => import("@/views/product/entranceGuardSoftware.vue"),
        meta: {
            metaInfo: {
                title: i18n.t("router.entranceGuardSoftware.title"),
                keywords: i18n.t("router.entranceGuardSoftware.keywords"),
                description: i18n.t("router.entranceGuardSoftware.description"),
            }
        }
    },
    {
        // 智能展柜软件
        path: "/product/softwarePlatform/exhibitionSoftware",
        name: "exhibitionSoftware",
        component: () => import("@/views/product/exhibitionSoftware.vue"),
        meta: {
            metaInfo: {
                title: i18n.t("router.exhibitionSoftware.title"),
                keywords: i18n.t("router.exhibitionSoftware.keywords"),
                description: i18n.t("router.exhibitionSoftware.description")
            }
        }
    },
    {
        // 售后服务平台
        path: "/product/softwarePlatform/aftTheSoftware",
        name: "aftTheSoftware",
        component: () => import("@/views/product/aftTheSoftware.vue"),
        meta: {
            metaInfo: {
                title: i18n.t("router.aftTheSoftware.title"),
                keywords: i18n.t("router.aftTheSoftware.keywords"),
                description: i18n.t("router.aftTheSoftware.description")
            }
        }
    },
    // {
    //     // 寻求合作
    //     path: "/support/cooperation",
    //     name: "cooperation",
    //     component: () => import("@/views/support/cooperation.vue"),
    //     meta: {
    //         title: "寻求合作",
    //     }
    // },
    {
        path: "/contact",
        name: "contact",
        component: () => import("@/views/contact.vue"),
        meta: {
            metaInfo: {
                title: i18n.t("router.contact.title"),
                keywords: i18n.t("router.contact.keywords"),
                description: i18n.t("router.contact.description"),
            }
        },
    },
    {
        path: "/product/productShow",
        name: "productShow",
        component: () => import("@/components/productShow.vue"),
        meta: {
            metaInfo: {
                title: i18n.t("router.productShow.title"),
                keywords: i18n.t("router.productShow.keywords"),
                description: i18n.t("router.productShow.description"),
            }
        },
    },
    {
        path: "/product/productShow/productInfoShow",
        name: "productInfoShow",
        component: () => import("@/components/productInfoShow.vue"),
        meta: {
            metaInfo: {
                title: i18n.t("router.productInfoShow.title"),
                keywords: i18n.t("router.productInfoShow.keywords"),
                description: i18n.t("router.productInfoShow.description"),
            }
        },
    },
    // {
    //     path: "/aftersales",
    //     name: "aftersales",
    //     component: () => import("@/views/aftersales.vue"),
    //     meta: {
    //         title: "售后支持",
    //     },
    //     children: []
    // },
    // {
    //     path: "/aftersales/commonProblems/problem",
    //     name: "problem",
    //     component: () => import("@/components/problem.vue"),
    //     meta: {
    //         title: "常见问题"
    //     }
    // },
    // 技术支持
    { // 智能门禁服务
        path: "/service/accessControlIntelligentSystemServices",
        name: "accessControlIntelligentSystemServices",
        component: () => import("@/views/service/accessControlIntelligentSystemServices.vue"),
        meta: {
            metaInfo: {
                title: i18n.t("router.accessControlIntelligentSystemServices.title"),
                keywords: i18n.t("router.accessControlIntelligentSystemServices.keywords"),
                description: i18n.t("router.accessControlIntelligentSystemServices.description"),
            }
        }
    },
    {// 智能展柜服务
        path: "/service/smartDisplayCaseService",
        name: "smartDisplayCaseService",
        component: () => import("@/views/service/smartDisplayCaseService.vue"),
        meta: {
            metaInfo: {
                title: i18n.t("router.smartDisplayCaseService.title"),
                keywords: i18n.t("router.smartDisplayCaseService.keywords"),
                description: i18n.t("router.smartDisplayCaseService.description"),
            }
        }
    },
    {
        // 智能储物柜服务
        path: "/service/smartLockersService",
        name: "smartLockersService",
        component: () => import("@/views/service/smartLockersService.vue"),
        meta: {
            metaInfo: {
                title: i18n.t("router.smartLockersService.title"),
                keywords: i18n.t("router.smartLockersService.keywords"),
                description: i18n.t("router.smartLockersService.description"),
            }
        }
    },
    {
        // 玻璃门智能拉手锁
        path: "/service/glassDoorHandleSmartLockService",
        name: "glassDoorHandleSmartLockService",
        component: () => import("@/views/service/glassDoorHandleSmartLockService.vue"),
        meta: {
            metaInfo: {
                title: i18n.t("router.glassDoorHandleSmartLockService.title"),
                keywords: i18n.t("router.glassDoorHandleSmartLockService.keywords"),
                description: i18n.t("router.glassDoorHandleSmartLockService.description"),
            }
        }
    },
    // {
    //     // 智慧建筑解决方案
    //     path: "/service/smartBuildingsService",
    //     name: "smartBuildingsService",
    //     component: () => import("@/views/service/smartBuildingsService.vue"),
    //     meta: {
    //         metaInfo: {
    //             title: "智慧建筑 | 上海杉脉科技",
    //             keywords: "智慧建筑,智能建筑解决方案,建筑智能化系统,智能家居系统,楼宇自动化系统,杉脉科技智慧建筑服务",
    //             description: "杉脉科技智慧建筑解决方案对室内的灯光、空调、窗帘、投影、幕布、新风等设备采用场景一键切换，如投影模式下电动窗帘自动合上，灯光自动调整亮度，投影幕布自动下拉启动投影设备，更清晰地展示投影效果，提升空间智能化管理水平。"
    //         }
    //     }
    // },
    {
        // rfid盘点服务
        path: "/service/rfidTakeService",
        name: "rfidTakeService",
        component: () => import("@/views/service/rfidTakeService.vue"),
        meta: {
            metaInfo: {
                title: i18n.t("router.rfidTakeService.title"),
                keywords: i18n.t("router.rfidTakeService.keywords"),
                description: i18n.t("router.rfidTakeService.description"),
            }
        }
    }


];
// title

const router = new VueRouter({
    routes,
    // mode: 'history',
    mode: 'hash',
    // 跳转页面后 回到顶部
    scrollBehavior() {
        return {
            x: 0,
            y: 0,
        };
    },

});

export default router;

//title
const defaultTitle = "杉脉科技";
router.beforeEach((to, from, next) => {
    if (to.meta.metaInfo) {
        store.commit("metaModule/CHANGE_META_INFO", to.meta.metaInfo)
    } else {
        document.title = to.meta.title ? to.meta.title : defaultTitle;
    }
    next();
});
